import {Component} from "@angular/core";
import {AbstractView} from "../../../views/AbstractView";

@Component({
  selector: 'link-access-denied',
  templateUrl: './access-denied.view.html',
  styleUrls: ['./access-denied.view.scss'],
})
export class AccessDeniedView extends AbstractView<any> {

  constructor() {
    super();
  }
}
